/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-21 11:04:50
 * @Description:
 * @FilePath: \mobile-revive\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import { getConfigInfo, getUsernfo} from '@/api/user'
import {Gpaq_set} from '@/utils/common'
import {
    CHANGLOADING,
    CHANGGOORBACK,
    MU_DDCONFIG,
    MU_USERINFO,
    MU_PEROTHERPER,
    MU_GRELEADER,
    MU_GTEXTAREA,
    MU_OTHERQUERYS
} from './mutations-types'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loading: false,
        transitonName: 'xh-slide', // 页面切换动画名字
        ddConfig: null, // 钉钉配置
        dduserInfo: null,
        ddOtherOption: false, // 是否显示其他人意见(董事长时，为true),默认false
        ddGReLeader: false, // 判断是集团地块负责人true还是投委会决策人false,默认false
        gTextarea: '', // 全局textarea 内容
        GotherQuerys: null, // 其他url参数
        userInfoName: '',
        keepAliveList: [], // 缓存页面列表
        userName: '旭辉'
    },
    getters: {
    // 判断上会的类型  1 集团 2 地区
        getInvenstType(state) {
            if (!state.invenstType) {
                state.invenstType = sessionStorage.userInfo ? sessionStorage.userInfo.confType : 1
            }
            return state.invenstType
        }
    },
    mutations: {
        [CHANGLOADING](state, payload) {
            state.loading = payload.value
        },
        [CHANGGOORBACK](state, payload) {
            state.transitonName = payload.value
        },
        [MU_DDCONFIG](state, payload) {
            state.ddConfig = payload
        },
        [MU_USERINFO](state, payload) {
            state.dduserInfo = payload
        },
        [MU_PEROTHERPER](state, payload) {
            state.ddOtherOption = payload.value
        },
        [MU_GRELEADER](state, payload) {
            state.ddGReLeader = payload.value
        },
        [MU_GTEXTAREA](state, payload) {
            state.gTextarea = payload.value
        },
        [MU_OTHERQUERYS](state, payload) {
            state.GotherQuerys = payload
        },
        setUserInfoName(state, params) {
            state.userInfoName = params
        },
        updateAliveList(state, { name, status }) {
            if (status) {
                const index = state.keepAliveList.indexOf(name)
                index == -1 && state.keepAliveList.push(name)
            } else {
                const index = state.keepAliveList.indexOf(name)
                index >= 0 && state.keepAliveList.splice(index, 1)
            }
        },
        setUserName(state, param = '旭辉') {
            state.userName = param
        }
    },
    actions: {
        GetDdConfig({commit}) {
            // 获取钉钉配置
            return new Promise(function(resolve, reject) {
                getConfigInfo({}).then(data => {
                    commit(MU_DDCONFIG, data.data)
                    resolve(data.data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },
        GetDdUserInfo({commit}, payload) {
            // 获取钉钉用户信息
            return new Promise((resolve, reject) => {
                getUsernfo({
                    code: payload.code
                }).then(data => {
                    let userInfo = data.data
                    let paqInfo = userInfo.userName + '_' + userInfo.mobile + '_' + userInfo.email
                    commit(MU_USERINFO, userInfo)
                    // 埋点用户信息
                    Gpaq_set(paqInfo)
                    resolve(data)
                }).catch((err) => {
                    reject(err)
                })
            })
        }
    }
})
